(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.section-related-with-recent');
    const sectionHeaderTitleRecentProducts = document.querySelector('.section-header_title[data-title="recent"]');
    const sectionHeaderTitleRelatedProducts = document.querySelector('.section-header_title[data-title="related"]');
    const allHeaders = section.querySelectorAll('.section-header_title');
    
    // Function to handle header clicks
    function handleHeaderClick(headerElement) {
      // Remove active class from all headers
      allHeaders.forEach(function(header) {
        header.classList.remove('active');
      });
      
      // Remove existing data-title classes from section
      section.classList.remove('recent', 'related');
      
      // Add active class to clicked header
      headerElement.classList.add('active');

      console.log('headerElement.dataset.title', headerElement.dataset.title);
      
      // Add the appropriate data-title class to section
      section.classList.add(headerElement.dataset.title);
    }
    
    // Add event listeners for recent products headers
    if (sectionHeaderTitleRecentProducts) {
      sectionHeaderTitleRecentProducts.addEventListener('click', function() {
        handleHeaderClick(sectionHeaderTitleRecentProducts);
      });
    }
    
    // Add event listeners for related products headers
    if (sectionHeaderTitleRelatedProducts) {
      sectionHeaderTitleRelatedProducts.addEventListener('click', function() {
        handleHeaderClick(sectionHeaderTitleRelatedProducts);
      });
    }

  });


  } catch(e) { console.error(e); }
})();
})();
